module.exports = __webpack_public_path__ + "static/media/Michael Saunders.6492fee1.png";